(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/common/assets/javascripts/helpers.js') >= 0) return;  svs.modules.push('/components/sportinfo/common/assets/javascripts/helpers.js');
"use strict";


const trinidad = svs.isServer ? require('@svenskaspelab/trinidad-core').core : svs.core;
const _ref = svs.isServer ? trinidad.components.require('utils', 'products') : svs.utils.products,
  productIds = _ref.productIds;
const sportInfoConstants = svs.isServer ? require('./constants.es6') : svs.components.sportinfo.common.constants;
const _ref2 = svs.isServer ? trinidad.components.require('lb-utils', 'cloud-api').cloudApiConstants : svs.components.lbUtils.cloudApi.cloudApiConstants,
  VALID_PRODUCTS_FOR_CLOUD_ENDPOINT_SPORTEVENT = _ref2.VALID_PRODUCTS_FOR_CLOUD_ENDPOINT_SPORTEVENT;
const _ref3 = svs.isServer ? trinidad.components.require('lb-utils', 'api-proxy').proxyHandler : svs.components.lbUtils.apiProxy,
  http = _ref3.http;
const featureToggle = svs.isServer ? trinidad.components.require('lb-utils', 'api-proxy').featureToggle : svs.components.lbUtils.apiProxy.featureToggle;
const AllKnownOutcomes = sportInfoConstants.AllKnownOutcomes,
  EventTypeId = sportInfoConstants.EventTypeId,
  EventTypeDistributionsFallback = sportInfoConstants.EventTypeDistributionsFallback,
  EventTypeField = sportInfoConstants.EventTypeField,
  ParticipantTypes = sportInfoConstants.ParticipantTypes,
  TypeForEventTypeField = sportInfoConstants.TypeForEventTypeField,
  OutcomeToAlphabeticStrings = sportInfoConstants.OutcomeToAlphabeticStrings,
  OutcomeToAlphabeticStringsOverUnder = sportInfoConstants.OutcomeToAlphabeticStringsOverUnder;
const createBetEventKey = (productId, drawId, eventNumber) => "".concat(productId, "_").concat(drawId, "_").concat(eventNumber);

const createEventStatisticsKey = _ref4 => {
  let matchId = _ref4.matchId,
    _ref4$eventTypeId = _ref4.eventTypeId,
    eventTypeId = _ref4$eventTypeId === void 0 ? EventTypeId.EVENT_1X2 : _ref4$eventTypeId,
    periodNumber = _ref4.periodNumber,
    eventNumber = _ref4.eventNumber;
  let eventStatisticsKey = "".concat(matchId, "_").concat(eventTypeId);

  if (eventNumber) {
    eventStatisticsKey += "_".concat(eventNumber);
  }
  if (typeof periodNumber === 'number' && periodNumber > 0) {
    eventStatisticsKey += "_P".concat(periodNumber);
  }
  return eventStatisticsKey;
};
const capitalize = str => {
  if (!str) {
    return str;
  }
  return str.slice(0, 1).toUpperCase() + str.slice(1);
};
const normalizeToDot = str => str ? "".concat(str).replace(/,/g, '.') : null;
const getValueForField = (values, fieldName) => values ? values[fieldName] : undefined;
const getValueForPreviousField = (values, outcome) => getValueForField(values, "ref".concat(capitalize(outcome)));
const normalizeValueField = function (eventTypeId, values, fn) {
  let allKnownOutcomes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : AllKnownOutcomes;
  const outcomes = allKnownOutcomes[eventTypeId] || ['one', 'x', 'two'];
  return outcomes.map(knownOutcome => {
    const field = fn(values, knownOutcome);
    return normalizeToDot(field);
  });
};
const normalizeEventTypeId = _ref5 => {
  let productId = _ref5.productId,
    _ref5$participantType = _ref5.participantType,
    participantType = _ref5$participantType === void 0 ? 'Team' : _ref5$participantType,
    eventTypeId = _ref5.eventTypeId;
  const isEventTypeIdH2H = productIds.POWERPLAY === productId && participantType === ParticipantTypes.Player;
  if (isEventTypeIdH2H) {
    return EventTypeId.HEAD_TO_HEAD;
  }
  return eventTypeId;
};
const normalizeEventTypeField = function (eventTypeId, eventTypeField, values) {
  let subkey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : EventTypeDistributionsFallback;
  const eventTypeFields = {};
  eventTypeFields[eventTypeField] = {};
  if (values) {
    if (eventTypeField === EventTypeField.Distributions) {
      const productIds = Object.keys(values);
      productIds.forEach(productId => {
        const value = values[productId];
        if (!eventTypeFields[eventTypeField][productId]) {
          eventTypeFields[eventTypeField][productId] = {};
        }
        const parsedDistribution = {
          current: {
            value: normalizeValueField(eventTypeId, value, getValueForField, AllKnownOutcomes),
            date: getValueForField(value, 'date')
          },
          previous: {
            value: normalizeValueField(eventTypeId, value, getValueForPreviousField, AllKnownOutcomes),
            date: getValueForPreviousField(value, 'date')
          },
          valueType: TypeForEventTypeField[eventTypeField]
        };
        eventTypeFields[eventTypeField][productId][subkey] = parsedDistribution;
      });
    } else {
      eventTypeFields[eventTypeField] = {
        current: {
          value: normalizeValueField(eventTypeId, values, getValueForField, AllKnownOutcomes)
        },
        valueType: TypeForEventTypeField[eventTypeField]
      };
    }
  }
  return eventTypeFields;
};
const normalizeOddsItem = (odds, eventTypeId) => {
  if (odds.length === 0) {
    return null;
  }
  const getOutcomeKey = outcome => {
    if (eventTypeId === EventTypeId.EVENT_1X2) {
      return OutcomeToAlphabeticStrings[outcome];
    }
    if (eventTypeId === EventTypeId.OVER_UNDER) {
      return OutcomeToAlphabeticStringsOverUnder[outcome];
    }
    return outcome;
  };
  return odds.reduce((acc, outcome) => {
    acc[getOutcomeKey(outcome.outcome)] = outcome.value;
    return acc;
  }, {});
};
const customSporteventApiHandler = http.get("/sport/1/sportevent/:sporteventId", _ref6 => {
  let data = _ref6.data;
  return data;
}, {
  config: {
    shouldUseCloud: async () => {
      const isEnabled = await featureToggle('ft-use-draw-proxy-sportevent-cloud-api', {
        req: undefined
      });
      return isEnabled;
    },
    validate: (params, options) => VALID_PRODUCTS_FOR_CLOUD_ENDPOINT_SPORTEVENT.includes(options.productId),
    allowedProducts: [],
    cloudEndpointTemplate: '/v1/sport/sportevents/:sporteventId'
  }
});
const customSporteventOddsApiHandler = http.get("/sport/2/sportevent/:sporteventId/odds", _ref7 => {
  let data = _ref7.data;
  return data;
}, {
  config: {
    shouldUseCloud: async () => {
      const isEnabled = await featureToggle('ft-use-draw-proxy-bomben-cloud-api', {
        req: undefined
      });
      return isEnabled;
    },
    validate: (params, options) => VALID_PRODUCTS_FOR_CLOUD_ENDPOINT_SPORTEVENT.includes(options.productId),
    allowedProducts: [],
    cloudEndpointTemplate: '/v1/sport/sportevents/:sporteventId/odds'
  }
});
const helperExports = {
  createBetEventKey,
  createEventStatisticsKey,
  normalizeEventTypeField,
  normalizeEventTypeId,
  normalizeOddsItem,
  normalizeToDot,
  customSporteventApiHandler,
  customSporteventOddsApiHandler
};
if (svs.isServer) {
  module.exports = helperExports;
} else {
  setGlobal('svs.components.sportinfo.common.helpers', helperExports);
}

 })(window);